import { TCaEventCreator, TEventDataParser } from '../types';
import { getSiteType } from '../getSiteType';
import { pipe } from 'ramda';
import { sendCaEvent } from '../sendCaEvent';

type TEventExtra = {};
type TEventData = {
  url: string;
};

const createEvent: TCaEventCreator<TEventExtra, TEventData> = props => ({
  name: 'oldevent',
  category: 'CardVac',
  action: 'Click',
  label: props.url,
  page: {
    siteType: props.siteType,
  },
});

type TRawData = {
  url: string;
};

const parseData: TEventDataParser<TRawData, TEventData> = rawData => ({
  ...rawData,
  siteType: getSiteType(rawData.deviceType),
});

export const sendClickBannerEvent = pipe(parseData, createEvent, sendCaEvent);
